<template>
  <a-upload
    style="width: 130px;"
    name="avatar"
    list-type="picture-card"
    class="avatar-uploader"
    :show-upload-list="false"
    :customRequest="uploadImg"
    :before-upload="beforeUpload"
    @change="handleChange"
    accept="image/*"
  >
    <div v-if="imageUrl || defaultUrl">
      <img style="width: 100px; height: 100px" :src="imageUrl || defaultUrl" alt="avatar" />
      <a-button @click.stop="deleteImg" size="small" type="danger">删除</a-button>
    </div>
    <div v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">
        Upload
      </div>
    </div>
  </a-upload>
</template>
<script>
import OssApi from '../api/src/oss/api/OssApi'
import { uploadImageMultipart } from '@/utils/ossMultipartImageUpload'

const ossApi = new OssApi()
export default {
  name: 'CommonUpload',
  props: {
    path: String,
    defaultUrl: String
  },
  data() {
    return {
      loading: false,
      imageUrl: '',
    };
  },
  methods: {
    deleteImg(e) {
      this.imageUrl = '';
      this.loading = false;
      this.$emit('changeImgUri', undefined)
      return false
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done' || info.file.status === 'error') {
        this.loading = false;
      }
    },
    async beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片文件!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('文件必须小于2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    async uploadImg(info) {
      const file = info.file.originFileObj || info.file
      const nameBase = String(info.file.uid != null ? info.file.uid : Date.now())
      try {
        const { url, uri } = await uploadImageMultipart(ossApi, file, this.path, nameBase)
        info.file.status = 'done'
        this.$emit('changeImgUri', uri)
        this.imageUrl = url
      } catch (err) {
        console.log(err)
        this.$message.error('上传失败')
        info.file.status = 'error'
      }
    },
  },
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
